import _regeneratorRuntime from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _, _2, _3, _4, _5, _6, _BEGIN_SUPPORT_GET_AC;
// packages/auth-toc-web/src/index.ts
import axios from "axios";
import { transform, platform } from "@lego/base";

// packages/auth-toc-web/src/utils.ts
import Bridge, { getAppVersion, compareAppVersion } from "app-webbridge";

// packages/auth-toc-web/src/types.ts
var AccountType = /* @__PURE__ */function (AccountType2) {
  AccountType2[AccountType2["Default"] = 0] = "Default";
  AccountType2[AccountType2["Shopee"] = 1] = "Shopee";
  AccountType2[AccountType2["Wmslite"] = 2] = "Wmslite";
  AccountType2[AccountType2["SPX"] = 3] = "SPX";
  AccountType2[AccountType2["Mitra"] = 4] = "Mitra";
  AccountType2[AccountType2["MainSub"] = 5] = "MainSub";
  AccountType2[AccountType2["Driver"] = 6] = "Driver";
  AccountType2[AccountType2["Bank"] = 11] = "Bank";
  AccountType2[AccountType2["OP"] = 12] = "OP";
  AccountType2[AccountType2["ShopeePayNonLogin"] = 16] = "ShopeePayNonLogin";
  AccountType2[AccountType2["FoodyToCUser"] = 17] = "FoodyToCUser";
  AccountType2[AccountType2["ShopeePayTHToCUser"] = 18] = "ShopeePayTHToCUser";
  AccountType2[AccountType2["ShopeeFood"] = 22] = "ShopeeFood";
  AccountType2[AccountType2["ShopeePayPartner"] = 23] = "ShopeePayPartner";
  AccountType2[AccountType2["MystockToB"] = 24] = "MystockToB";
  AccountType2[AccountType2["MitraToB"] = 25] = "MitraToB";
  AccountType2[AccountType2["ShopeeToB"] = 30] = "ShopeeToB";
  AccountType2[AccountType2["ShopeeConsignmentServiceToBUser"] = 31] = "ShopeeConsignmentServiceToBUser";
  AccountType2[AccountType2["WmsliteNologin"] = 102] = "WmsliteNologin";
  AccountType2[AccountType2["ShopeeNonLogin"] = 103] = "ShopeeNonLogin";
  AccountType2[AccountType2["BankPHNonLogin"] = 104] = "BankPHNonLogin";
  AccountType2[AccountType2["BankIDNonLogin"] = 105] = "BankIDNonLogin";
  return AccountType2;
}(AccountType || {});

// packages/auth-toc-web/src/utils.ts
var BEGIN_SUPPORT_GET_ACCESS_TOKEN_VERSION_MAPPING = (_BEGIN_SUPPORT_GET_AC = {}, _defineProperty(_BEGIN_SUPPORT_GET_AC, 25 /* MitraToB */, (_ = {}, _defineProperty(_, "IOS" /* IOS */, {
  default: 31700
}), _defineProperty(_, "Android" /* Android */, {
  default: 31700
}), _)), _defineProperty(_BEGIN_SUPPORT_GET_AC, 30 /* ShopeeToB */, (_2 = {}, _defineProperty(_2, "IOS" /* IOS */, {
  default: 31700
}), _defineProperty(_2, "Android" /* Android */, {
  default: 31700
}), _2)), _defineProperty(_BEGIN_SUPPORT_GET_AC, 22 /* ShopeeFood */, (_3 = {}, _defineProperty(_3, "IOS" /* IOS */, {
  default: 71700
}), _defineProperty(_3, "Android" /* Android */, {
  default: 72100
}), _3)), _defineProperty(_BEGIN_SUPPORT_GET_AC, 6 /* Driver */, (_4 = {}, _defineProperty(_4, "IOS" /* IOS */, {
  vn: "12.45.0",
  default: "7.20.0"
}), _defineProperty(_4, "Android" /* Android */, {
  vn: "12.45.0",
  default: "7.20.0"
}), _4)), _defineProperty(_BEGIN_SUPPORT_GET_AC, 104 /* BankPHNonLogin */, (_5 = {}, _defineProperty(_5, "IOS" /* IOS */, {
  default: 10500
}), _defineProperty(_5, "Android" /* Android */, {
  default: 10500
}), _5)), _defineProperty(_BEGIN_SUPPORT_GET_AC, 105 /* BankIDNonLogin */, (_6 = {}, _defineProperty(_6, "IOS" /* IOS */, {
  default: 10500
}), _defineProperty(_6, "Android" /* Android */, {
  default: 10500
}), _6)), _BEGIN_SUPPORT_GET_AC);
var isIOS = function isIOS() {
  return typeof window.isIOS === "function" && window.isIOS();
};
var isAndroid = function isAndroid() {
  return typeof window.isAndroid === "function" && window.isAndroid();
};
function getBeginSupportGetAccessTokenVersion(accountType, region) {
  var supportAccessTokenAppVersions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : BEGIN_SUPPORT_GET_ACCESS_TOKEN_VERSION_MAPPING;
  var _a;
  var curPlatform = "Web" /* Web */;
  if (isIOS()) {
    curPlatform = "IOS" /* IOS */;
  } else if (isAndroid()) {
    curPlatform = "Android" /* Android */;
  }

  var mapping = (_a = supportAccessTokenAppVersions == null ? void 0 : supportAccessTokenAppVersions[accountType]) == null ? void 0 : _a[curPlatform];
  if (!mapping) {
    return void 0;
  }
  if (!region || !(region in mapping)) {
    return mapping.default;
  }
  return mapping[region];
}
function getLiveChatAppVersion() {
  try {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("livechat") >= 0) {
      var version = ua.match(/livechatver=(\d*)/);
      if (version && !Number.isNaN(Number(version[1]))) {
        return Number(version[1]);
      }
    }
    return 0;
  } catch (_unused) {
    return 0;
  }
}
var ACCOUNT_TYPES_USE_LIVE_CHAT_VER = [104 /* BankPHNonLogin */, 105 /* BankIDNonLogin */];
var isSupportGetAccessToken = function isSupportGetAccessToken(accountType, region, supportAccessTokenAppVersions) {
  var curVersion = ACCOUNT_TYPES_USE_LIVE_CHAT_VER.includes(accountType) ? getLiveChatAppVersion() : getAppVersion();
  var beginSupportLiveChatGetTokenVersion = getBeginSupportGetAccessTokenVersion(accountType, region, supportAccessTokenAppVersions);
  return !!curVersion && !!beginSupportLiveChatGetTokenVersion && compareAppVersion(curVersion, beginSupportLiveChatGetTokenVersion) >= 0;
};
var getChatAccessToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(accountType, region, saasId, supportAccessTokenAppVersions) {
    var _a, _b, _c, res, _ref2, code, data, errorData;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isSupportGetAccessToken(accountType, region, supportAccessTokenAppVersions)) {
              _context.next = 2;
              break;
            }
            throw new Error("Not support liveChatGetToken bridge");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return Bridge.callBridge("liveChatGetToken", {
              sdk_param: JSON.stringify({
                entrypoint: 0,
                accountType: Number(accountType),
                saasId: saasId
              })
            });
          case 5:
            res = _context.sent;
            _ref2 = res || {}, code = _ref2.code, data = _ref2.data;
            if (!(code === 0 && ((_a = data == null ? void 0 : data.response) == null ? void 0 : _a.code) === 0 && ((_c = (_b = data == null ? void 0 : data.response) == null ? void 0 : _b.data) == null ? void 0 : _c.access_token))) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", data.response.data.access_token);
          case 9:
            throw new Error("Call liveChatGetToken err \u2014\u2014 ".concat(JSON.stringify(res)));
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            errorData = (_context.t0 == null ? void 0 : _context.t0.data) || _context.t0;
            throw new Error("Call getChatAccessToken err \u2014\u2014 ".concat(errorData.message || errorData));
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function getChatAccessToken(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var getBankNonLoginAccessToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(accountType, region, supportAccessTokenAppVersions) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              if (!isSupportGetAccessToken(accountType, region, supportAccessTokenAppVersions)) {
                reject(new Error("Not support bankDFP bridge"));
              }
              try {
                window.bridgeCallHandler("bankDFP", void 0, function (res) {
                  var newRes = res;
                  if (newRes == null ? void 0 : newRes.dfp) {
                    resolve(newRes == null ? void 0 : newRes.dfp);
                  }
                  reject(new Error("Call bankDFP err \u2014\u2014 ".concat(JSON.stringify(res))));
                });
              } catch (error) {
                reject(new Error("Call getBankNonLoginAccessToken err \u2014\u2014 ".concat(JSON.stringify(error))));
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getBankNonLoginAccessToken(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

// packages/auth-toc-web/src/index.ts
var DEFAULT_AUTH_PATH = "/api/inhouse/auth/v2/get_access_token";
function setChannelAccessToken(_x8) {
  return _setChannelAccessToken.apply(this, arguments);
}
function _setChannelAccessToken() {
  _setChannelAccessToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(props) {
    var accountType, extension, _props$baseUrl, baseUrl, _props$urlPath, urlPath, supportAccessTokenAppVersions, _platform$parse, defaultRegion, saasId, region, credential, scheme, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            accountType = props.accountType, extension = props.extension, _props$baseUrl = props.baseUrl, baseUrl = _props$baseUrl === void 0 ? window.location.origin : _props$baseUrl, _props$urlPath = props.urlPath, urlPath = _props$urlPath === void 0 ? DEFAULT_AUTH_PATH : _props$urlPath, supportAccessTokenAppVersions = props.supportAccessTokenAppVersions;
            _platform$parse = platform.parse(baseUrl), defaultRegion = _platform$parse.region, saasId = _platform$parse.saasId;
            region = props.region || defaultRegion;
            credential = props.credential;
            _context4.t0 = accountType;
            _context4.next = _context4.t0 === 1 /* Shopee */ ? 7 : _context4.t0 === 5 /* MainSub */ ? 7 : _context4.t0 === 25 /* MitraToB */ ? 8 : _context4.t0 === 30 /* ShopeeToB */ ? 8 : _context4.t0 === 6 /* Driver */ ? 8 : _context4.t0 === 22 /* ShopeeFood */ ? 8 : _context4.t0 === 104 /* BankPHNonLogin */ ? 13 : _context4.t0 === 105 /* BankIDNonLogin */ ? 13 : 17;
            break;
          case 7:
            return _context4.abrupt("break", 18);
          case 8:
            _context4.next = 10;
            return getChatAccessToken(accountType, region, saasId, supportAccessTokenAppVersions);
          case 10:
            credential = _context4.sent;
            scheme = 1;
            return _context4.abrupt("break", 18);
          case 13:
            _context4.next = 15;
            return getBankNonLoginAccessToken(accountType, region, supportAccessTokenAppVersions);
          case 15:
            credential = _context4.sent;
            return _context4.abrupt("break", 18);
          case 17:
            throw new Error("Unsupported account type: ".concat(accountType));
          case 18:
            _context4.prev = 18;
            _context4.next = 21;
            return axios.post("".concat(baseUrl).concat(urlPath), {
              account_type: accountType,
              credential: credential,
              extension: extension,
              scheme: scheme
            }, {
              headers: {
                "shopee-region": region
              }
            });
          case 21:
            response = _context4.sent;
            return _context4.abrupt("return", transform.camelizeObject(response.data));
          case 25:
            _context4.prev = 25;
            _context4.t1 = _context4["catch"](18);
            throw new Error("Failed to set channel access token: ".concat(_context4.t1.message || _context4.t1));
          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[18, 25]]);
  }));
  return _setChannelAccessToken.apply(this, arguments);
}
function createChannelAccessTokenResponseInterceptor(props) {
  var accountType = props.accountType,
    credential = props.credential,
    extension = props.extension,
    requestInstance = props.requestInstance,
    region = props.region,
    baseUrl = props.baseUrl,
    urlPath = props.urlPath,
    supportAccessTokenAppVersions = props.supportAccessTokenAppVersions,
    _props$useDetailedErr = props.useDetailedError,
    useDetailedError = _props$useDetailedErr === void 0 ? false : _props$useDetailedErr;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(response) {
      var config, error, statusText;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              config = response.config, error = response.error, statusText = response.statusText;
              if (!(error && [401, 403].includes(error.status))) {
                _context3.next = 11;
                break;
              }
              _context3.prev = 2;
              _context3.next = 5;
              return setChannelAccessToken({
                accountType: accountType,
                credential: credential,
                extension: extension,
                baseUrl: baseUrl,
                region: region,
                urlPath: urlPath,
                supportAccessTokenAppVersions: supportAccessTokenAppVersions
              });
            case 5:
              return _context3.abrupt("return", requestInstance ? requestInstance(config) : axios(config));
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
              return _context3.abrupt("return", Promise.reject(useDetailedError ? {
                error: _context3.t0
              } : _context3.t0));
            case 11:
              return _context3.abrupt("return", Promise.reject(useDetailedError ? response : error || new Error(statusText || "Error")));
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 8]]);
    }));
    return function (_x9) {
      return _ref4.apply(this, arguments);
    };
  }();
}
export { AccountType, createChannelAccessTokenResponseInterceptor, setChannelAccessToken };